import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../../reducers';
import { updateFolderTree } from '../../../../containers/DriveItemList/actions';
import { Translate } from 'react-redux-i18n';
import { StyledUpdateFolderTreeButton } from './styles';
import Utils from '../../../../utils';

interface UpdateFolderTreeButtonProps {
	isOffline: boolean;
	isBusy: boolean;
	dispatch: Dispatch<StoreState>;
}

const UpdateFolderTreeButton = ({ isOffline, isBusy, dispatch }: UpdateFolderTreeButtonProps) => {
	const showSpinner = isBusy && !isOffline;
	const isDisabled = isOffline || isBusy;

	const onClick = () => {
		if (!isDisabled) {
			dispatch(updateFolderTree(true));
		}
	};

	return (
		<StyledUpdateFolderTreeButton
			isUpdating={showSpinner}
			isOffline={isOffline}
			disabled={isDisabled}
			onClick={onClick}
		>
			{showSpinner && Utils.getSvgIcon('iconset_loading')}
			<Translate value="messages.update_folder_tree" />
		</StyledUpdateFolderTreeButton>
	);
};

export default UpdateFolderTreeButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/ActionButtons/UpdateFolderTreeButton/index.tsx